import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { addI18nTranslations } from "../../utils";

export default {
    title:
        "Components/Stateful Filter & Content/Stateful Content/Stateful Table",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-stateful-table",
    args: {
        maxFixedColWidth: "add default manually",
        scope: "statefultable",
        url: "generated-mock-data/stateful-content.json",
    },
    argTypes: {
        maxFixedColWidth: {
            control: "number",
        },
        scope: {
            control: "text",
        },
        url: {
            control: "text",
        },
    },
};

const Template = ({ maxFixedColWidth, scope, url }) => {
    addI18nTranslations({
        namespace: "statefultable",
        language: "de-DE",
        translations: {
            content: {
                isFav: {
                    column: "Translated 1",
                },
                name: {
                    column: "Translated 2",
                },
                latestAvailableVersion: {
                    column: "Translated 3",
                },
                serviceAgreementStatus: {
                    column: "Translated 4",
                    values: {
                        SERVICE_AGREEMENT_Inactive:
                            "keine aktive Servicevereinbarung",
                        SERVICE_AGREEMENT_Active: "Aktiv",
                    },
                },
            },
        },
    });

    return html`<ux-iws-stateful-table
        max-fixed-col-width="${maxFixedColWidth}"
        scope="${scope}"
        url="${url}"
    ></ux-iws-stateful-table>`;
};

export const Default = Template.bind({});
